import {
  areaCategory,
  elementCategory,
  hazardCategory,
  facilityCategory,
  zoneTypeList,
  emptyPropElements,
  zonePrefixList,
  heatMapValidKeynames,
  heatMapZoneTypeList,
  courseMapValidKeynames,
  courseMapZoneTypeList,
  faciltyHazardType,
  faciltyHazardSize,
  backroundType,
  courseMapElementLimit,
  faciltyHazardAreaSize,
  faciltyHazardNativeAreaType,
  faciltyHazardNativeAreaDesc,
  BridgePolygonDescription,
  faciltyHazardCliffDesc,
  faciltyHazardCliffType,
  BunkerPolygonType,
  BunkerPolygonDescription,
  backroundDesc,
  faciltyFixtureType,
  faciltyHazardTreeDescription,
  faciltyForestType,
  creekSize,
  lavaType,
  residenceDesc,
  residenceType,
  residenceSize,
  buildingDesc,
  buildingType,
  buildingSize,
  parkingLotDesc,
  streetDesc,
  streetSize,
  fenceDesc,
  fenceSize,
  waterDesc,
  waterType,
  waterSize,
  cartPathDesc,
  clubhouseDesc,
  clubhouseType,
  clubhouseSize,
} from "json/constants";
import CryptoJS from "crypto-js";
import asset from "json/assets";
import L from "leaflet";
import {
  booleanPointInPolygon,
  point,
  polygon as turfPolygon,
  union as turfUnion,
  buffer as turfBuffer,
  simplify as turfSimplify,
  area as turfArea,
  nearestPointOnLine,
  distance as turfDistance,
  lineString as turfLineString,
  centroid as turfCentroid,
} from "@turf/turf";
import * as _ from "underscore";
import {
  collectTeeboxCenters,
  findTeeboxWithoutCenter,
} from "services/teeboxCenterValidation";
const moment = require('moment');

export const hasShiftedPlaceholderCoordinates = (gpsList) => {
  if (!Array.isArray(gpsList)) return false;
  const nearZero = (value) =>
    Number.isFinite(Number(value)) && Math.abs(Number(value)) < 0.01;
  const isShiftedPair = (lat, lng) =>
    nearZero(lat) &&
    nearZero(lng) &&
    (Number(lat) !== 0 || Number(lng) !== 0);
  const pairKeys = [
    ["frontLat", "frontLon"],
    ["centerLat", "centerLon"],
    ["backLat", "backLon"],
  ];
  for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
    pairKeys.push([`teeLat${i}`, `teeLon${i}`]);
  }
  for (let i = 1; i <= courseMapElementLimit.hazard; i++) {
    pairKeys.push([`customLat${i}`, `customLon${i}`]);
  }
  return gpsList.some(
    (row) =>
      row &&
      pairKeys.some(([latKey, lngKey]) =>
        isShiftedPair(row[latKey], row[lngKey])
      )
  );
};

export const convertToLabelName = (string) => {
  let strArray = string?.split(/(?=[A-Z])/);
  let a = strArray?.map((item) => item.charAt(0).toUpperCase() + item.slice(1));
  let name = a?.join(" ");
  return name;
};
export const convertToLabelWithAttributesType = (shapeData) => {
  if(shapeData?.label === "Vegetation" && shapeData?.Attributes?.Type){
    const matchedValue = faciltyHazardType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Nativearea" && shapeData?.Attributes?.Type){
   const matchedValue = faciltyHazardNativeAreaType.find((item) => item.value === shapeData?.Attributes?.Type);
   return matchedValue?.label
  }else if(shapeData?.label === "Sand" && shapeData?.Attributes?.Type ){
    const matchedValue = BunkerPolygonType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Bunker" && shapeData?.Attributes?.Type ){
    const matchedValue = BunkerPolygonType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label ===  "Background" && shapeData?.Attributes?.Type){
    const matchedValue = backroundType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Fixtures" && shapeData?.Attributes?.Type){
    const matchedValue = faciltyFixtureType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Tree" && shapeData?.Attributes?.Type){
    const matchedValue = faciltyHazardType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Forest" && shapeData?.Attributes?.Type){
    const matchedValue = faciltyForestType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "PracticeBunker" && shapeData?.Attributes?.Type){
    const matchedValue = BunkerPolygonType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Lava" && shapeData?.Attributes?.Type){
    const matchedValue = lavaType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Residence" && shapeData?.Attributes?.Type){
    const matchedValue = residenceType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if((shapeData?.label === "Condo" || shapeData?.label === "Hotel" || shapeData?.label === "Business") && shapeData?.Attributes?.Type){
    const matchedValue = buildingType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Water" && shapeData?.Attributes?.Type){
    const matchedValue = waterType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Cliff" && shapeData?.Attributes?.Type){
    const matchedValue = faciltyHazardCliffType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }else if(shapeData?.label === "Clubhouse" && shapeData?.Attributes?.Type){
    const matchedValue = clubhouseType.find((item) => item.value === shapeData?.Attributes?.Type);
    return matchedValue?.label
  }
};
export const convertToLabelWithAttributesDesc = (shapeData) => {
  if(shapeData?.label === "Bridge" && shapeData?.Attributes?.Description){
    const matchedValue = BridgePolygonDescription.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Nativearea" && shapeData?.Attributes?.Description ){
    const matchedValue = faciltyHazardNativeAreaDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Cliff" && shapeData?.Attributes?.Description){
    const matchedValue = faciltyHazardCliffDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Sand" && shapeData?.Attributes?.Description ){
    const matchedValue = BunkerPolygonDescription.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Bunker" && shapeData?.Attributes?.Description ){
    const matchedValue = BunkerPolygonDescription.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label ===  "Background" && shapeData?.Attributes?.Description){
    const matchedValue = backroundDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label ===  "Tree" && shapeData?.Attributes?.Description  ){
    const matchedValue = faciltyHazardTreeDescription.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "PracticeBunker" && shapeData?.Attributes?.Description){
    const matchedValue = BunkerPolygonDescription.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Residence" && shapeData?.Attributes?.Description){
    const matchedValue = residenceDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if((shapeData?.label === "Condo" || shapeData?.label === "Hotel" || shapeData?.label === "Business") && shapeData?.Attributes?.Description){
    const matchedValue = buildingDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "ParkingLot" && shapeData?.Attributes?.Description){
    const matchedValue = parkingLotDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Street" && shapeData?.Attributes?.Description){
    const matchedValue = streetDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Fence" && shapeData?.Attributes?.Description){
    const matchedValue = fenceDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Water" && shapeData?.Attributes?.Description){
    const matchedValue = waterDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Path" && shapeData?.Attributes?.Description){
    const matchedValue = cartPathDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }else if(shapeData?.label === "Clubhouse" && shapeData?.Attributes?.Description){
    const matchedValue = clubhouseDesc.find((item) => item.value === shapeData?.Attributes?.Description);
    return matchedValue?.label
  }

}
export const convertToLabelWithAttributesSize = (shapeData) => {
  if(shapeData?.label === "Vegetation" && shapeData?.Attributes?.Size){
    const matchedValue = faciltyHazardSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Nativearea" && shapeData?.Attributes?.Size ){
    const matchedValue = faciltyHazardAreaSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }
  else if(shapeData?.label === "Fixtures" && shapeData?.Attributes?.Size ){
    const matchedValue = faciltyHazardAreaSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }
  else if(shapeData?.label === "Tree" && shapeData?.Attributes?.Size ){
    const matchedValue = faciltyHazardSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  } else if(shapeData?.label === "PracticeBunker" && shapeData?.Attributes?.Size ){
    const matchedValue = faciltyHazardSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Creek" && shapeData?.Attributes?.Size){
    const matchedValue = creekSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Residence" && shapeData?.Attributes?.Size){
    const matchedValue = residenceSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if((shapeData?.label === "Condo" || shapeData?.label === "Hotel" || shapeData?.label === "Business") && shapeData?.Attributes?.Size){
    const matchedValue = buildingSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Street" && shapeData?.Attributes?.Size){
    const matchedValue = streetSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Fence" && shapeData?.Attributes?.Size){
    const matchedValue = fenceSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Water" && shapeData?.Attributes?.Size){
    const matchedValue = waterSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }else if(shapeData?.label === "Clubhouse" && shapeData?.Attributes?.Size){
    const matchedValue = clubhouseSize.find((item) => item.value === shapeData?.Attributes?.Size);
    return matchedValue?.label
  }
}

export const convertObjectToArray = (obj) => {
  if (Array.isArray(obj)) {
    return obj;
  } else {
    let convertedArray = new Array(obj);
    return convertedArray;
  }
};

// Helper that ensures a URL has a scheme so anchor tags don't treat it as a relative path.
// Returns the value unchanged if it already has any scheme (http, https, mailto, etc.).
// Returns "" for blank/null inputs so empty fields don't navigate anywhere.
export const normalizeUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (/^[a-z][a-z0-9+\-.]*:/i.test(trimmed)) return trimmed;
  if (trimmed.startsWith("//")) return `https:${trimmed}`;
  return `https://${trimmed}`;
};

export const isLoggedIn = () => {
  const secretKey = decryptSecretKey();
  return secretKey ? true : false;
};

export const catagorizeShapeData = (shapeData) => {
  let facilty = {};
  let area = {};
  let hazard = {};
  let element = {};

  if (shapeData && Object.keys(shapeData).length > 0) {
    Object.keys(shapeData)?.forEach((shape, index) => {
      if (facilityCategory.includes(shape)) {
        facilty = { ...facilty, [`${shape}`]: shapeData[shape] };
      }
      if (areaCategory.includes(shape)) {
        area = { ...area, [`${shape}`]: shapeData[shape] };
      }
      if (hazardCategory.includes(shape)) {
        hazard = { ...hazard, [`${shape}`]: shapeData[shape] };
      }
      if (elementCategory.includes(shape)) {
        element = { ...element, [`${shape}`]: shapeData[shape] };
      }
    });
  }

  return { facilty, area, hazard, element };
};

export const isObjectEmpty = (object) => {
  return Object.keys(object).length === 0 ? true : false;
};

export const isNumeric = (str) => {
  if (typeof str != "string") return false; // we only process strings!
  return !isNaN(str) && !isNaN(parseFloat(str));
};

export const drawingOptions = (useImperialUnits, showUnits) => {
  return {
    rectangle: {
      feet: false,
      metric: false,

      // showArea: showUnits,
      // showRadius: showUnits,
      // feet: useImperialUnits,
      // metric: !useImperialUnits,
      // nautic: false
    },
    polygon: {
      feet: false,
      metric: false,
      // showArea: showUnits,
      // showLength: showUnits,
      // showRadius: showUnits,
      // feet: useImperialUnits,
      // metric: !useImperialUnits,
      // nautic: false
    },
    circle: {
      feet: false,
      metric: false,
      // showRadius: showUnits,
      // feet: useImperialUnits,
      // metric: !useImperialUnits,
      // nautic: false
    },
    polyline: {
      feet: false,
      metric: false,
      // showLength: showUnits,
      // feet: useImperialUnits,
      // metric: !useImperialUnits,
      // nautic: false
    },
  };
};

export const preparePointsToLatLong = (points) => {
  let temp = [];
  let pointsList = [];
  let latlongList = points.split(" "); // (._.')
  latlongList.forEach((point, index) => {
    let latlng = point.split(",");
    temp.push([parseFloat(latlng[0]), parseFloat(latlng[1])]);
  });

  pointsList.push(temp);
  return pointsList;
};

export const prepareHeatMapPointsToLatLong = (points) => {
  let temp = [];
  let pointsList = [];
  let latlongList = points.split(","); // (>_<')
  latlongList.forEach((point, index) => {
    let latlng = point.split(" ");
    temp.push([parseFloat(latlng[1]), parseFloat(latlng[0])]);
  });

  pointsList.push(temp);
  return pointsList;
};

export const getBoundsAndElementWisePoints = (shapeData) => {
  let boundList = [];
  let temp = [];
  let elementWiseList = [];
  Object.keys(shapeData)?.forEach((shapeName, index) => {
    shapeData[`${shapeName}`]?.forEach((item, index) => {
      elementWiseList.push({
        mod2: item?.mod2,
        list: preparePointsToLatLong(item?.points[0]),
        label: item?.label,
        zone: shapeName,
        type: item?.type,
      });
      // indentifying each polygon with label and color code.

      temp.push(preparePointsToLatLong(item?.points[0]));
    });
  });

  temp.flat().flatMap((s) => {
    boundList.push(s[0]);
  });

  return { boundList, elementWiseList };
};

export const getHeatMapBoundsAndElementWisePoints = (shapeData) => {
  let boundList = [];
  let temp = [];
  let elementWiseList = [];
  Object.keys(shapeData)?.forEach((shapeName, index) => {
    shapeData[`${shapeName}`]?.forEach((item, index) => {
      elementWiseList.push({
        mod2: item?.mod2,
        list: prepareHeatMapPointsToLatLong(item?.points[0]),
        label: item?.label,
        hole: item?.hole || -1, //creek,paths etc is not belong to any particular hole.
        zone: shapeName,
        type: item?.type,
      });
      // indentifying each polygon with label and color code.

      temp.push(prepareHeatMapPointsToLatLong(item?.points[0]));
    });
  });

  temp.flat().flatMap((s) => {
    boundList.push(s[0]);
  });

  return { boundList, elementWiseList };
};

export const getCourseMapBoundsAndElementWisePoints = (shapeData) => {
  try {
    let boundList = [];
    let temp = [];
    let elementWiseList = [];
    // let background=[]

    
    Object.keys(shapeData)?.forEach((shapeName, index) => {
      if (shapeName !== "clubhousecenter")
        shapeData[`${shapeName}`]?.forEach((item, _index) => {
      const labelName=item?.label==="NativeArea"?'Nativearea' :item?.label;
          let _data = {};
        
          
          if (isValidCourseMapKeyName(shapeName)) {
            _data = {
              // mod2: item?.mod2,
              list: prepareHeatMapPointsToLatLong(item?.points),
              label: labelName,
              hole: item?.hole || -1, //tree etc is not belong to any particular hole.
              zone: shapeName,
              type: item?.type,
              _id: item?._id,
            };
            if (item?.Attributes) {
              _data.Attributes = item?.Attributes; // for items which have attribute values
            }
          } else {
            _data = {
              mod2: item?.mod2,
              list: prepareHeatMapPointsToLatLong(item?.points[0]),
              label:labelName,
              hole: item?.hole || -1, //tree etc is not belong to any particular hole.
              zone: shapeName,
              type: item?.type,
              _id: item?._id,
            };
            if (item?.Attributes) {
              _data.Attributes = item?.Attributes; // for items which have attribute values
            }
          }
          shapeName === "Teeboxcenter" && (_data.teeboxID = item?.teeboxID);
          shapeName === "Greencenter" && (_data.greenID = item?.greenID);

          if (shapeName === "Perimeter") {
            elementWiseList.unshift(_data);
          } else {
            elementWiseList.push(_data);
          }

          // indentifying each polygon with label and color code.

          if (shapeName === "background") {
            // temp.push(prepareHeatMapPointsToLatLong(item?.points[0]));
            temp.push(prepareHeatMapPointsToLatLong(item?.points));
          }
        });
    });

    boundList = temp.flat(2);

    return { boundList, elementWiseList };
  } catch (error) {
    console.error("getCourseMapBoundsAndElementWisePoints error", error);
  }
};

export const decryptSecretKey = () => {
  let data = localStorage.getItem("secretKey");
  const key = process.env.REACT_APP_KEY;
  let decryptedKey;
  if (data) {
    decryptedKey = CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
  }

  return decryptedKey;
};
export const isColor = (word) => {
  return word && word.includes("#");
};
export const getModalProperties = () => {
  return {
    warning: {
      icon: asset.warningicon,
      backgroundColor: "#F8BB1F",
      btnBackground: "#212B36",
    },
    error: {
      icon: asset.close,
      backgroundColor: "#F34650",
    },
    success: {
      icon: asset.sucessicon,
      backgroundColor: "#133E84",
    },
    info: {
      icon: asset.update,
      backgroundColor: "#133E84",
    },
  };
};

export const convertPolygonDataToString = (pointData) => {
  let stringifiedPoint = "";
  if (Array.isArray(pointData)) {
    //for polygon and polylne
    let tempArray = [];
    pointData?.forEach((polyItem, index) => {
      let str = `${polyItem?.lat},${polyItem?.lng}`;
      tempArray.push(str);
    });
    stringifiedPoint = tempArray.join(" ");
  } else {
    // for marker
    let str = `${pointData?.lat},${pointData?.lng}`;
    stringifiedPoint = str;
  }
  return stringifiedPoint;
};

export const convertCoursePolygonDataToString = (pointData) => {
  let stringifiedPoint = "";
  if (Array.isArray(pointData)) {
    //for polygon and polylne
    let tempArray = [];

    pointData?.forEach((polyItem, index) => {
      // let str = `${polyItem?.lat},${polyItem?.lng}`;
      let str =
        index !== pointData?.length - 1
          ? `${polyItem?.lng} ${polyItem?.lat},`
          : `${polyItem?.lng} ${polyItem?.lat}`;

      tempArray.push(str);
    });
    // stringifiedPoint = tempArray.join(" ");
    stringifiedPoint = tempArray.join("");
  } else {
    // for marker
    let str = `${pointData?.lat},${pointData?.lng}`;
    stringifiedPoint = str;
  }
  return stringifiedPoint;
};

export const convertToAPIPayload = (
  pointsData,
  shapeData,
  areaName,
  zone,
  zoneMod1,
  zoneMod2
) => {
  let temp_shapeData = structuredClone(shapeData);

  if (shapeData?.hasOwnProperty(zone)) {
    let currentData = temp_shapeData[`${zone}`];
    if (Array.isArray(currentData)) {
      let temp_currentData = [...currentData];
      let pos = temp_currentData?.findIndex((s) => s.label === areaName);
      if (pos !== -1) {
        // edit
        temp_currentData[pos].points = [pointsData];
        if (zoneMod2) {
          temp_currentData[pos].mod2 = zoneMod2;
        }
        if (zoneMod1) {
          temp_currentData[pos].mod1 = zoneMod1;
        }
        temp_shapeData[`${zone}`] = temp_currentData;
      } else {
        let temp_currentData = [...currentData];
        let shapeType = temp_currentData[0]?.type; // as all the shapes will have the same properties, we can choose any one
        let mod1Type = temp_currentData[0]?.mod1 || "";

        let polyData = {
          label: areaName,
          mod1: mod1Type,
          mod2: zoneMod2 || "#057716",
          points: [pointsData],
          type: shapeType,
        };

        temp_currentData.push(polyData);
        temp_shapeData[`${zone}`] = temp_currentData;
      }
    }
  }

  return temp_shapeData;
};

function findNumericStartPosition(word) {
  // Regular expression pattern to match the start of numeric data
  var pattern = /^\D*(\d+)/;

  // Executing the regular expression on the word
  var result = pattern.exec(word);

  if (result && result[1]) {
    // The index where the numeric data starts
    var startPosition = word.indexOf(result[1]);
    return startPosition;
  }

  // If no numeric data is found
  return -1;
}
export const convertAddedShapeToPayload = (
  pointsData,
  shapeData,
  zone,
  prefix,
  zoneMod2,
  type
) => {
  let zoneSpecific = [
    "landingAreas",
    "facilityMarker",
    "perimeter",
    "netting",
    "poles",
    "hittingAreas",
    "stalls",
    "vegetation",
    "treeAreas",
    "trees",
    "targets",
    "waterHazards",
    "markers",
  ];

  let temp_shapeData = structuredClone(shapeData);
  let currentData = temp_shapeData[`${zone}`];

  if (shapeData?.hasOwnProperty(zone)) {
    if (Array.isArray(currentData)) {
      let lastAddedZone = currentData?.at(-1)?.label;
      let numberPosition = findNumericStartPosition(lastAddedZone);
      let zoneNumber =
        currentData?.length !== 0
          ? parseInt(
              lastAddedZone.slice(numberPosition, lastAddedZone?.length)
            ) + 1
          : 1;
      let temp_currentData = [...currentData];
      let shapeType = temp_currentData[0]?.type;
      let mod1Type = temp_currentData[0]?.mod1 || "";

      // for zones with no modals
      if (!zoneSpecific.includes(zone)) {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: null,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "markers") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: zoneMod2 ? zoneMod2 : null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "vegetation") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "landingAreas") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: zoneMod2 ? zoneMod2 : null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "facilityMarker") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: null,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "perimeter") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: null,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "netting") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: null,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }
      if (zone === "poles") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "hittingAreas") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: zoneMod2 ? zoneMod2 : null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }
      if (zone === "stalls") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "treeAreas") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "trees") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: zoneMod2 ? zoneMod2 : null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "targets") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: type || mod1Type,
            mod2: zoneMod2 ? zoneMod2 : null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }

      if (zone === "waterHazards") {
        pointsData?.forEach((item, index) => {
          let polyData = {
            type: shapeType || zoneTypeList[`${zone}`],
            label: `${prefix}${zoneNumber}`,
            mod1: null,
            mod2: zoneMod2 ? zoneMod2 : null,
            points: [item],
          };
          temp_currentData.push(polyData);
          zoneNumber++;
        });
        temp_shapeData[`${zone}`] = temp_currentData;
      }
    }
  }

  return temp_shapeData;
};

export const DefaultMarkerIcon = new L.Icon.Default({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export const isEmptyProp = (zone) => {
  return emptyPropElements?.includes(zone);
};

export const convertAPIResposeToUsableShape = (shapes) => {
  let usableShape = {};
  if (shapes && Array.isArray(shapes) && shapes.length > 0) {
    shapes.forEach((item) => {
      const key = Object.keys(item)[0];
      usableShape[key] = item[key];
    });
  }
  return usableShape;
};

export const checkPayloadDataAvailable = (shapePayload) => {
  let flag = false;
  for (let key in shapePayload) {
    if (Array.isArray(shapePayload[key]) && shapePayload[key]?.length > 0) {
      flag = true;
    }
  }
  return flag;
};

export const convertSingleLatLngStringtoFloatArray = (
  item,
  separator = ","
) => {
  return [
    parseFloat(item?.split(separator)[0]),
    parseFloat(item?.split(separator)[1]),
  ];
};

export const checkAndUnionArrays = (array1, array2) => {
  // Check if both arrays have the same elements
  const isEqual =
    array1.length === array2.length &&
    array1.every((element) => array2.includes(element));

  // Create a new array with the union of all elements
  const unionArray = [...new Set([...array1, ...array2])];

  return {
    isEqual,
    unionArray,
  };
};

export const getPrefixFromLabel = (str) => {
  const regex = /^[A-Za-z]+/;
  const match = str.match(regex);
  return match ? match[0] : "";
};
export const getNumberFromLabel = (str) => {
  const regex = /\d+/;
  const match = str.match(regex);
  return match ? parseInt(match[0]) : null;
};
export const getSelectedZoneFromEditableArea = (editableArea) => {
  let prefix = getPrefixFromLabel(editableArea);
  let selectedZone = Object.keys(zonePrefixList)?.find(
    (s) => zonePrefixList[`${s}`] === prefix
  );
  return selectedZone;
};

export const getHeatMapDataIndexFromLabel = (str) => {
  const parts = str.split("_");
  const result = parts.map((part) => parseInt(part, 10));

  return {
    rowIndex: result[0],
    columnIndex: result[1],
    singleRowIndex: result[2],
  };
  // const regex = /heat_(\d+)/;
  // const match = str.match(regex);
  // const numericalValue = parseInt(match[1]);
  // return numericalValue
};
export const configElevationDataPromise = (elevationDetails) => {
  return new Promise((resolve, reject) => {
    let elelist = elevationDetails.elevationArray;
    let initLat = elevationDetails.maxLatitude;
    let initLng = elevationDetails.minLongitude;
    let step = elevationDetails.step;
    let arr3 = [];
    // let main = {};
    let GeoJSONArr = [];
    elelist.forEach((eleRowItem, eleRowIndex) => {
      let currentLat = initLat;
      let currentLng = initLng;
      let rowArray = [];
      eleRowItem.forEach((eleValue, eleValueIndex) => {
        let temp = [
          currentLat - step * eleRowIndex,
          currentLng + step * eleValueIndex,
          eleValue,
        ];

        // currentLng = currentLng + (step * eleValueIndex);

        arr3.push(temp);
        rowArray.push(temp);

        GeoJSONArr.push(
          point(
            [
              currentLng + step * eleValueIndex,
              currentLat - step * eleRowIndex,
            ],
            {
              elevationValue: eleValue,
              position: { rowIndex: eleRowIndex, columnIndex: eleValueIndex },
              label: `${eleRowIndex}_${eleValueIndex}_${GeoJSONArr?.length}`,
            }
          )
        );
      });
    });
    const thirdElements = arr3.map((subarray) => subarray[2]);
    // Calculate the average of the third elements
    const sum = thirdElements.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    const average = sum / thirdElements.length;
    const max = Math.max(...thirdElements);
    const min = Math.min(...thirdElements);

    // Assuming the processing inside the function is asynchronous
    // You can resolve or reject the promise accordingly based on your actual implementation
    // For now, I'm just resolving the promise.

    resolve({
      elevationDetails: arr3,
      averageElevation: average,
      maxElevation: max,
      minElevation: min,
      // rowWiseList: main,
      HeatMapJSONArray: GeoJSONArr,
    });
  });
};

export const convertHeatMapData = (heatMapShapeData) => {
  return new Promise((resolve, reject) => {
    try {
      let resultObject = {};
      let holeWiseObject = {};
      if (Object.keys(heatMapShapeData)?.length > 0) {
        Object.keys(heatMapShapeData)?.forEach((name) => {
          if (isValidHeatMapKeyName(name)) {
            let zoneItem = heatMapShapeData[`${name}`]?.Shapes?.Shape;
            let zoneObject = [];
            zoneItem?.forEach((singleObject, index) => {
              zoneObject.push({
                points: Object.values(singleObject),
                // label: `${name} ${index + 1}`,
                label: `${name}`,
                type: heatMapZoneTypeList[`${name}`.toLowerCase()],
              });
            });
            resultObject = {
              ...resultObject,
              [`${name}`.toLowerCase()]: zoneObject,
            };
          } else if (name === "Holes") {
            let holeWiseData = structuredClone(
              heatMapShapeData[`${name}`][`Hole`]
            );
            holeWiseData?.forEach((holeItem, holeIndex) => {
              Object.keys(holeItem)?.forEach((shapeItem, shapeIndex) => {
                if (
                  shapeItem !== "HoleNumber" &&
                  shapeItem !== "Teeboxcenter" &&
                  shapeItem !== "Centralpath"
                ) {
                  //removed teebox marker
                  holeItem[`${shapeItem}`]?.Shapes?.Shape.forEach(
                    (item, index) => {
                      if (!holeWiseObject[shapeItem]) {
                        holeWiseObject[shapeItem] = [];
                      }
                      holeWiseObject[shapeItem].push({
                        // label: `${shapeItem} ${index+1}`,
                        label: `${shapeItem}`,
                        hole: holeIndex + 1,
                        points: [item.Points],
                        type: heatMapZoneTypeList[
                          `${shapeItem.toLocaleLowerCase()}`
                        ],
                      });
                    }
                  );
                }
              });
            });
          }
        });
        resolve({ ...resultObject, ...holeWiseObject });
      }
    } catch (error) {
      reject({});
    }
  });
};

export const countShapePoints = (pointsStr) => {
  if (typeof pointsStr !== "string") return 0;
  return pointsStr
    .trim()
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .length;
};

export const collectInvalidShapes = (courseMapData) => {
  const out = [];
  if (!courseMapData) return out;

  const inspect = (shape, name, type, hole) => {
    if (type !== "line" && type !== "polygon") return;
    const min = type === "line" ? 2 : 3;
    const count = countShapePoints(shape?.Points);
    if (count < min && shape?.id) {
      out.push({ id: shape.id, name, hole, type, pointCount: count });
    }
  };

  Object.keys(courseMapData).forEach((name) => {
    if (isValidCourseMapKeyName(name)) {
      const type = courseMapZoneTypeList[`${name}`.toLowerCase()];
      courseMapData[`${name}`]?.Shapes?.Shape?.forEach((s) =>
        inspect(s, name, type, -1)
      );
    } else if (name === "Holes") {
      courseMapData.Holes?.Hole?.forEach((hole, idx) => {
        Object.keys(hole).forEach((key) => {
          if (key === "HoleNumber") return;
          const type = heatMapZoneTypeList[`${key}`.toLowerCase()];
          hole[`${key}`]?.Shapes?.Shape?.forEach((s) =>
            inspect(s, key, type, idx + 1)
          );
        });
      });
    }
  });

  return out;
};

export const convertCourseMapData = (courseMapData) => {
  return new Promise((resolve, reject) => {
    try {
      let resultObject = {};
      let holeWiseObject = {};
      if (Object.keys(courseMapData)?.length > 0) {
        Object.keys(courseMapData)?.forEach((name) => {
          if (isValidCourseMapKeyName(name)) {
            let zoneItem = courseMapData[`${name}`]?.Shapes?.Shape;
            let zoneObject = [];

            zoneItem?.forEach((singleObject, index) => {
              const _data = {
                // points: Object.values(singleObject),
                points: singleObject.Points,

                // label: `${name} ${index + 1}`,
                label: `${name}`,
                type: courseMapZoneTypeList[`${name}`.toLowerCase()],
                _id: singleObject?.id,
              };
              if (singleObject?.Attributes) {
                _data.Attributes = singleObject?.Attributes;
              }

              zoneObject.push(_data);
            });
            resultObject = {
              ...resultObject,
              [`${name}`.toLowerCase()]: zoneObject,
              // [`${name}`]: zoneObject,
            };
          } else if (name === "Holes") {
            let holeWiseData = structuredClone(
              courseMapData[`${name}`][`Hole`]
            );
            holeWiseData?.forEach((holeItem, holeIndex) => {
              Object.keys(holeItem)?.forEach((shapeItem, shapeIndex) => {
                if (
                  shapeItem !== "HoleNumber"
                  // && shapeItem !== "Teeboxcenter"
                  // && shapeItem !== "Centralpath"
                ) {
                   if (shapeItem === "Perimeter") {
                    // this if() part is for testing as some of the testing coruses had multiple perimeters per hole
                    // which should not be the case.
                    let perimeters = holeItem[`${shapeItem}`]?.Shapes?.Shape;
                    if (!_.isEmpty(perimeters)) {
                      const _data = {
                        label: `${shapeItem}`,
                        hole: holeIndex + 1,
                        points: [perimeters[0].Points],
                        type: heatMapZoneTypeList[
                          `${shapeItem.toLocaleLowerCase()}`
                        ],
                        _id: perimeters[0]?.id,
                      };
                      if (!holeWiseObject[shapeItem]) {
                        holeWiseObject[shapeItem] = [];
                      }
                      holeWiseObject[shapeItem].push(_data);
                    }
                  } else {
                    holeItem[`${shapeItem}`]?.Shapes?.Shape.forEach(
                      (item, index) => {
                        if (!holeWiseObject[shapeItem]) {
                          holeWiseObject[shapeItem] = [];
                        }

                        const _data = {
                          // label: `${shapeItem} ${index+1}`,
                          label: `${shapeItem}`,
                          hole: holeIndex + 1,
                          points: [item.Points],
                          type: heatMapZoneTypeList[
                            `${shapeItem.toLocaleLowerCase()}`
                          ],
                          _id: item?.id,
                        };
                        if (item?.Attributes) {
                          _data.Attributes = item?.Attributes;
                        }

                        shapeItem === "Teeboxcenter" &&
                          (_data.teeboxID =
                            holeItem["Teebox"]?.Shapes.Shape[index]?.id);
                        shapeItem === "Greencenter" &&
                          (_data.greenID =
                            holeItem["Green"]?.Shapes.Shape[index]?.id);

                        holeWiseObject[shapeItem].push(_data);
                      }
                    );
                  }
                }
              });
            });
          }
        });
        resolve({ ...resultObject, ...holeWiseObject });
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const isValidHeatMapKeyName = (name) => {
  if (typeof name === "string") {
    return heatMapValidKeynames?.includes(name.toLowerCase());
  } else return false;
};

export const isValidCourseMapKeyName = (name) => {
  if (typeof name === "string") {
    return courseMapValidKeynames?.includes(name.toLowerCase());
  } else return false;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const createVisibleCourseItemList = (courseMapData) => {
  return new Promise((resolve, reject) => {
    let CourseElements = [];
    let FacilityElements = {};
    try {
      courseMapData?.Holes?.Hole?.forEach((item, index) => {
        let emptyHoleElements = {};
        Object.keys(item)?.forEach((el, index) => {
          let idList = [];
          if (el === "HoleNumber") {
            // Skip this iteration when el is 'HoleNumber'
            return;
          }
          if (el === "Teeboxcenter") {
            item["Teebox"]?.Shapes?.Shape?.forEach((item, index) => {
              idList.push(item?.id);
            });
          }
          if (el === "Greencenter") {
            item["Green"]?.Shapes?.Shape?.forEach((item, index) => {
              idList.push(item?.id);
            });
          }
          item[el]?.Shapes?.Shape?.forEach((item, index) => {
            idList.push(item?.id);
          });
          emptyHoleElements[`${el}`] = {
            isElementVisible: true,
            idList: idList,
          };
        });
        CourseElements.push(emptyHoleElements);
      });

      courseMapValidKeynames.forEach((nm, index) => {
        
        // let shapeList = 
        // nm === "nativearea" 
        // ? courseMapData[`${capitalizeFirstLetter("nativeArea")}`].Shapes?.Shape?.map(
        //   (_item) => _item.id
        // )
        // : 
        // courseMapData[`${capitalizeFirstLetter(nm)}`]?.Shapes
        // ?.Shape
        // ? courseMapData[`${capitalizeFirstLetter(nm)}`].Shapes?.Shape?.map(
        //     (_item) => _item.id
        //   )
        // : [];
        // Multi-word element names need their actual camelCase API key
        // (capitalizeFirstLetter only capitalizes the first letter,
        // e.g. "parkinglot" -> "Parkinglot" but the API uses "ParkingLot").
        const canonicalApiKey = nm === "nativearea"
          ? "NativeArea"
          : nm === "parkinglot"
          ? "ParkingLot"
          : capitalizeFirstLetter(nm);

        let shapeList = courseMapData[canonicalApiKey]?.Shapes?.Shape?.map(_item => _item.id) ?? [];

        // Storage key must match the label used at render-time in
        // getActiveFacilityFeatureIcon. ParkingLot's label is "ParkingLot",
        // so we must store it under that exact key (NativeArea keeps legacy
        // storage key "Nativearea" because its label is normalized to that).
        const storageKey = nm === "parkinglot" ? "ParkingLot" : capitalizeFirstLetter(nm);

        FacilityElements[storageKey] = {
          isGroupVisible: nm === "tree" ? false : true,
          idList:  shapeList,
          // idList:[]
        };
      });
      // resolve(CourseElements);
      resolve({ CourseElements, FacilityElements });
    } catch (error) {
      reject(undefined);
    }

    // Resolve the promise with CourseElements
  });
};

export const convertLatLngStringToLngLatString = (latLngString) => {
  // latLngString =
  //   "32.90318630024021,-117.25208580493928 32.9031817963302,-117.25166201591493 32.90274941990313,-117.25162446498872 32.90272239630634,-117.25162446498872";
  if (latLngString) {
    const pairs = latLngString.split(" ");
    const outputCoords = pairs.map((pair) => {
      const [lat, lon] = pair.split(",");
      return `${lon} ${lat}`;
    });
    const outputStr = outputCoords.join(",");
    return outputStr;
  }

  // -117.24566593766 32.904431622569,-117.24575847387 32.904369694657
};


export const countKeyName = (object, string = "customName") => {
  var count = 0;
  for (var key in object) {
    if (key.startsWith(string)) {
      count++;
    }
  }
  return count;
};
export const LatLngStringtoLatLngArray = (inputArray) => {
  const arrayOfLatLngObjects = inputArray.map((latLngString) => {
    const [lat, lng] = latLngString.split(",").map(Number);
    return { lat, lng };
  });
  return arrayOfLatLngObjects;
};

export const getTypeFromAttribute = (value) => {
  return faciltyHazardType.find((s) => s.value === value)?.label;
};

export const getSizeFromAttribute = (value) => {
  return faciltyHazardSize.find((s) => s.value === value)?.label;
};
export const getSizeFromAttributeForNativeFixture = (value) => {
  return faciltyHazardAreaSize.find((s) => s.value === value)?.label;
};
export const getDescFromAttribute = (value) => {
  return backroundType.find((s) => s.value === value)?.label || "";
};
export const getDescFromAttributeBunker = (value) => {
  return BunkerPolygonDescription.find((s) => s.value === value)?.label;
};

export const getPopUpTitle = (editableArea, selectedZoneType) => {
  if (selectedZoneType?.hole === -1 || editableArea?.hole === -1) {
    // for faciltywise elements
    if (!_.isEmpty(editableArea)) {
      return `Edit ${editableArea.label}`;
    } else {
      return `Add ${selectedZoneType.element}`;
    }
  } else {
    //holewise elements
    if (!_.isEmpty(editableArea)) {
      if(editableArea?.label === "Bunker"){
        return editableArea?.label
        ? `Edit ${editableArea?.label}`
        : `Edit ${editableArea?.type}`;
      }else{
        return editableArea?.type
        ? `Edit ${editableArea?.type}`
        : `Edit ${editableArea?.label}`;
      }
    } else {
      return selectedZoneType?.element
        ? `Add ${selectedZoneType?.element}`
        : `Add ${selectedZoneType?.label}`;
    }
  }
};

export const dataCheck = (
  VectorData,
  SimpleData,
  transformedHoleData,
  transformedCourseData
) => {
  return new Promise((resolve, reject) => {
    try {
      let errMsg = "";
      let success = true;


      //Simple Data check.
      if (SimpleData) {
        //checking if clubhousecenter exists
        if (
          (!SimpleData?.clubLat && !SimpleData?.clubLon) ||
          (SimpleData?.clubLat === -1 && SimpleData?.clubLon === 1)
        ) {
          errMsg = "Clubhousecenter is missing.";
          success = false;
          reject({ errMsg, success });
        }
        if (SimpleData?.GPSList) {
          for (let i = 0; i < SimpleData?.layoutHoles; i++) {
            let currentHole = i + 1;

            let SimpleHoleData = SimpleData?.GPSList[i];

            //checking for emoty front,center, back
            if (
              !SimpleHoleData?.frontLat ||
              !SimpleHoleData?.frontLon ||
              !SimpleHoleData?.centerLat ||
              !SimpleHoleData?.centerLon ||
              !SimpleHoleData?.backLat ||
              !SimpleHoleData?.backLon
            ) {
              errMsg = `Hole ${i + 1}  is missing its front, center, or back. `;
              success = false;
              reject({ errMsg, success });
            }
            // checking for emoty teecenters
            let emptyTeecenterCount = 0;
            for (let j = 1; j <= 5; j++) {
              const customLat = SimpleHoleData[`teeLat${j}`];
              const customLon = SimpleHoleData[`teeLon${j}`];

              if (
                customLat === -1 ||
                customLat === 0 ||
                customLat === undefined ||
                customLon === -1 ||
                customLon === 0 ||
                customLon === undefined
              ) {
                emptyTeecenterCount++;
              }
            }
            if (emptyTeecenterCount === 5) {
              // no teeboxcenter is placed
              errMsg = `Teeboxcenters missing in Hole ${i + 1}`;
              success = false;
              reject({ errMsg, success });
            }

            if (transformedHoleData) {
              let perimeterData = transformedHoleData?.find(
                (s) => s.hole === currentHole && s.label === "Perimeter"
              ); //
              let SimpleHoleObject = SimpleData?.GPSList?.find(
                (s) => s.holeNumber === currentHole
              );
              if (perimeterData) {
                const perimeterBBox = perimeterData?.list;
                //Simple data elements inside perimeter check
                if (SimpleHoleObject) {
                  //checking green front is outside perimeter
                  if (
                    SimpleHoleObject?.frontLat &&
                    SimpleHoleObject?.frontLon
                  ) {
                    let isFrontInsidePerimeter = booleanPointInPolygon(
                      [SimpleHoleObject?.frontLat, SimpleHoleObject?.frontLon],
                      {
                        type: "Polygon",
                        coordinates: perimeterBBox,
                      }
                    );

                    if (!isFrontInsidePerimeter) {
                      errMsg = `Front of hole ${SimpleHoleData?.holeNumber} is outside its perimeter`;
                      success = false;
                      reject({ errMsg, success });
                    }
                  }
                  //checking green center is outside perimeter
                  if (
                    SimpleHoleObject?.centerLat &&
                    SimpleHoleObject?.centerLon
                  ) {
                    let isFrontInsidePerimeter = booleanPointInPolygon(
                      [
                        SimpleHoleObject?.centerLat,
                        SimpleHoleObject?.centerLon,
                      ],
                      {
                        type: "Polygon",
                        coordinates: perimeterBBox,
                      }
                    );

                    if (!isFrontInsidePerimeter) {
                      errMsg = `Center of hole ${SimpleHoleData?.holeNumber} is outside its perimeter`;
                      success = false;
                      reject({ errMsg, success });
                    }
                  }

                  //checking green back is outside perimeter
                  if (SimpleHoleObject?.backLat && SimpleHoleObject?.backLon) {
                    let isFrontInsidePerimeter = booleanPointInPolygon(
                      [SimpleHoleObject?.backLat, SimpleHoleObject?.backLon],
                      {
                        type: "Polygon",
                        coordinates: perimeterBBox,
                      }
                    );

                    if (!isFrontInsidePerimeter) {
                      errMsg = `Center of hole ${SimpleHoleData?.holeNumber} is outside its perimeter`;
                      success = false;
                      reject({ errMsg, success });
                    }
                  }
                  //checking if teebox center is inside perimeter
                  for (
                    let j = 1;
                    j <= courseMapElementLimit.teeboxcenter;
                    j++
                  ) {
                    // const customLat = SimpleHoleData[`teeLat${j}`];
                    // const customLon = SimpleHoleData[`teeLon${j}`];
                    const customLat = SimpleHoleObject[`teeLat${j}`];
                    const customLon = SimpleHoleObject[`teeLon${j}`];

                    if (customLat && customLon) {
                      let isTeeCenterInsideBackGround = booleanPointInPolygon(
                        [customLat, customLon],
                        {
                          type: "Polygon",
                          coordinates: perimeterBBox,
                        }
                      );
                      if (!isTeeCenterInsideBackGround) {
                        errMsg = `Tee center of hole ${SimpleHoleData?.holeNumber} is outside the perimeter`;
                        success = false;
                        reject({ errMsg, success });
                      }
                    }
                  }
                  //checking if
                  for (let j = 1; j <= courseMapElementLimit.hazard; j++) {
                    const customLat = SimpleHoleObject[`customLat${j}`];
                    const customLon = SimpleHoleObject[`customLon${j}`];
                    const hazardName = SimpleHoleObject[`customName${j}`];

                    if (customLat && customLon) {
                      let isTeeCenterInsideBackGround = booleanPointInPolygon(
                        [customLat, customLon],
                        {
                          type: "Polygon",
                          coordinates: perimeterBBox,
                        }
                      );
                      if (!isTeeCenterInsideBackGround) {
                        errMsg = `Hazard  ${hazardName} of hole ${SimpleHoleData?.holeNumber} is outside its perimeter`;
                        success = false;
                        reject({ errMsg, success });
                      }
                    }
                  }
                }

                //FairWay inside perimeter
                let FairWayData = transformedHoleData?.filter(
                  (s) => s.hole === currentHole && s.label === "Fairway"
                ); //
                if (FairWayData) {
                  for (let i = 0; i < FairWayData?.length; i++) {
                    let FData = FairWayData[i];
                    const polygonCoordinates = FData?.list[0];
                    for (const coord of polygonCoordinates) {
                      let isFairWayInsidePerimeter = booleanPointInPolygon(
                        coord,
                        {
                          type: "Polygon",
                          coordinates: perimeterBBox,
                        }
                      );
                      if (!isFairWayInsidePerimeter) {
                        errMsg = `${FData?.label} of hole ${FData?.hole} is outside its perimeter`;
                        success = false;
                        reject({ errMsg, success });
                      }
                    }
                  }
                }

                //Teebox inside perimeter
                 let TeeboxList = transformedHoleData?.filter(
                  (s) => s.hole === currentHole && s.label === "Teebox"
                );
                if (TeeboxList) {
                  for (let i = 0; i < TeeboxList?.length; i++) {
                    let TData = TeeboxList[i];
                    const polygonCoordinates = TData?.list[0];

                    for (const coord of polygonCoordinates) {
                      let isTeeboxInsidePerimeter = booleanPointInPolygon(
                        coord,
                        {
                          type: "Polygon",
                          coordinates: perimeterBBox,
                        }
                      );

                      if (!isTeeboxInsidePerimeter) {
                        errMsg = `One of the ${TData?.label} of hole ${TData?.hole} is outside its perimeter`;
                        success = false;
                        reject({ errMsg, success });
                      }
                    }
                  }
                }

                    //Green inside perimeter
                    let GreenData = transformedHoleData?.find(
                      (s) => s.hole === currentHole && s.label === "Green"
                    ); //
                    if (GreenData) {
                      const polygonCoordinates = GreenData?.list[0];

                      for (const coord of polygonCoordinates) {
                        let isFairWayInsidePerimeter = booleanPointInPolygon(
                          coord,
                          {
                            type: "Polygon",
                            coordinates: perimeterBBox,
                          }
                        );

                        if (!isFairWayInsidePerimeter) {
                          errMsg = `${GreenData?.label} of hole ${GreenData?.hole} is outside its perimeter`;
                          success = false;
                          reject({ errMsg, success });
                        }
                      }
                    }

                    //Centralpath inside perimeter
                    let CPathData = transformedHoleData?.find(
                      (s) => s.hole === currentHole && s.label === "Centralpath"
                    ); //
                      if(CPathData){
                        const polygonCoordinates = CPathData?.list[0];
                        for (const coord of polygonCoordinates) {
                          let isLineInsideBackGround = booleanPointInPolygon(coord, {
                            type: "Polygon",
                            coordinates: perimeterBBox,
                          });
          
                          if (!isLineInsideBackGround) {
                            errMsg = `${CPathData?.label} of hole ${CPathData.hole} is outside its perimeter`;
                            success = false;
                            reject({ errMsg, success });
                          }
                        }
                      }
              }
              const holeTeeboxes = transformedHoleData?.filter(
                (s) => s.hole === currentHole && s.label === "Teebox"
              );
              const teeboxWithoutCenter = findTeeboxWithoutCenter(
                holeTeeboxes,
                collectTeeboxCenters(SimpleHoleObject)
              );
              if (teeboxWithoutCenter) {
                errMsg = `Teebox of hole ${currentHole} has no Teeboxcenter inside it`;
                success = false;
                reject({ errMsg, success });
              }
            }
          }
        }
      }

      // Vector Data check
      if (VectorData) {
        //checking for Background
        if (
          !VectorData?.Background ||
          VectorData?.Background?.ShapeCount === 0
        ) {
          errMsg = "Background is missing. ";
          success = false;
          reject({ errMsg, success });
        }
        const HoleData = VectorData?.Holes?.Hole;
        for (let i = 0; i < VectorData?.LayoutHoles; i++) {
          if (!HoleData[i]?.Teebox || HoleData[i]?.Teebox?.ShapeCount === 0) {
            errMsg = `Teebox is missing in Hole ${i + 1}  `;
            success = false;
            reject({ errMsg, success });
          }
          if (!HoleData[i]?.Green || HoleData[i]?.Green?.ShapeCount === 0) {
            errMsg = `Green is missing in Hole ${i + 1}  `;
            success = false;
            reject({ errMsg, success });
          }
          if (
            !HoleData[i]?.Greencenter ||
            HoleData[i]?.Greencenter?.ShapeCount === 0
          ) {
            errMsg = `Greencenter is missing in Hole ${i + 1}  `;
            success = false;
            reject({ errMsg, success });
          }
          if (
            !HoleData[i]?.Perimeter ||
            HoleData[i]?.Perimeter?.ShapeCount === 0
          ) {
            errMsg = `Perimeter is missing in Hole ${i + 1}  `;
            success = false;
            reject({ errMsg, success });
          }
          if (
            !HoleData[i]?.Centralpath ||
            HoleData[i]?.Centralpath?.ShapeCount === 0
          ) {
            errMsg = `Centralpath is missing in Hole ${i + 1}  `;
            success = false;
            reject({ errMsg, success });
          }
          // for mandatory fairway
          // if (!HoleData[i]?.Fairway || HoleData[i]?.Fairway?.ShapeCount === 0) {
          //   errMsg = `Fairway is missing in Hole ${i + 1}  `;
          //   success = false;
          //   reject({ errMsg, success });
          // }
        }
        // reject({ errMsg, success }); // reject if error
      }

      // if exists inside background
      if (transformedCourseData && transformedHoleData) {
        const backgroundBounds = transformedCourseData?.find(
          (s) => s.label === "Background"
        )?.list;

        if (backgroundBounds) {
          transformedCourseData?.forEach((s) => {
            if (s.type === "point") {
              let isPointInsideBackGround = booleanPointInPolygon(
                s?.list[0][0],
                {
                  type: "Polygon",
                  coordinates: backgroundBounds,
                }
              );
              if (!isPointInsideBackGround) {
                errMsg = `One or more ${s?.label} is outside the background`;
                success = false;
                reject({ errMsg, success });
              }
            } else if (s.type === "line") {
              const polygonCoordinates = s?.list[0];
              for (const coord of polygonCoordinates) {
                let isLineInsideBackGround = booleanPointInPolygon(coord, {
                  type: "Polygon",
                  coordinates: backgroundBounds,
                });

                if (!isLineInsideBackGround) {
                  errMsg = `One or more ${s?.label} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }
            } else if (s.type === "polygon") {
              const polygonCoordinates = s?.list[0];
              for (const coord of polygonCoordinates) {
                let isPolygonInsideBackGround = booleanPointInPolygon(coord, {
                  type: "Polygon",
                  coordinates: backgroundBounds,
                });

                if (!isPolygonInsideBackGround) {
                  errMsg = `One or more ${s?.label} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }
            }
          });

          transformedHoleData?.forEach((s) => {
            if (s.type === "point" && s.label !== "Greencenter") {
              let isPointInsideBackGround = booleanPointInPolygon(
                s?.list[0][0],
                {
                  type: "Polygon",
                  coordinates: backgroundBounds,
                }
              );
              if (!isPointInsideBackGround) {
                errMsg = `One or more ${s?.label} is outside the background`;
                success = false;
                reject({ errMsg, success });
              }
            } else if (s.type === "line") {
              const polygonCoordinates = s?.list[0];
              for (const coord of polygonCoordinates) {
                let isLineInsideBackGround = booleanPointInPolygon(coord, {
                  type: "Polygon",
                  coordinates: backgroundBounds,
                });

                if (!isLineInsideBackGround) {
                  errMsg = `One or more ${s?.label} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }
            } else if (s.type === "polygon") {
              const polygonCoordinates = s?.list[0];
              for (const coord of polygonCoordinates) {
                let isPolygonInsideBackGround = booleanPointInPolygon(coord, {
                  type: "Polygon",
                  coordinates: backgroundBounds,
                });

                if (!isPolygonInsideBackGround) {
                  errMsg = `One or more ${s?.label} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }
            }
          });

          if (SimpleData && SimpleData?.GPSList) {
            for (let i = 0; i < SimpleData?.layoutHoles; i++) {
              let SimpleHoleData = SimpleData?.GPSList[i];
              //checking green front is outside
              if (SimpleHoleData?.frontLat && SimpleHoleData?.frontLon) {
                let isPointInsideBackGround = booleanPointInPolygon(
                  [SimpleHoleData?.frontLat, SimpleHoleData?.frontLon],
                  {
                    type: "Polygon",
                    coordinates: backgroundBounds,
                  }
                );
                if (!isPointInsideBackGround) {
                  errMsg = `Front of hole ${SimpleHoleData?.holeNumber} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }
              //checking green center is outside
              if (SimpleHoleData?.centerLat && SimpleHoleData?.centerLon) {
                let isCenterInsideBackGround = booleanPointInPolygon(
                  [SimpleHoleData?.centerLat, SimpleHoleData?.centerLon],
                  {
                    type: "Polygon",
                    coordinates: backgroundBounds,
                  }
                );
                if (!isCenterInsideBackGround) {
                  errMsg = `Center of hole ${SimpleHoleData?.holeNumber} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }
              //checking green back is outside
              if (SimpleHoleData?.backLat && SimpleHoleData?.backLon) {
                let isBackInsideBackGround = booleanPointInPolygon(
                  [SimpleHoleData?.backLat, SimpleHoleData?.backLon],
                  {
                    type: "Polygon",
                    coordinates: backgroundBounds,
                  }
                );
                if (!isBackInsideBackGround) {
                  errMsg = `Back of hole ${SimpleHoleData?.holeNumber} is outside the background`;
                  success = false;
                  reject({ errMsg, success });
                }
              }

              for (let j = 1; j <= courseMapElementLimit.teeboxcenter; j++) {
                const customLat = SimpleHoleData[`teeLat${j}`];
                const customLon = SimpleHoleData[`teeLon${j}`];

                if (customLat && customLon) {
                  let isTeeCenterInsideBackGround = booleanPointInPolygon(
                    [customLat, customLon],
                    {
                      type: "Polygon",
                      coordinates: backgroundBounds,
                    }
                  );
                  if (!isTeeCenterInsideBackGround) {
                    errMsg = `Tee center of hole ${SimpleHoleData?.holeNumber} is outside the background`;
                    success = false;
                    reject({ errMsg, success });
                  }
                }
              }

              for (let j = 1; j <= courseMapElementLimit.hazard; j++) {
                const customLat = SimpleHoleData[`customLat${j}`];
                const customLon = SimpleHoleData[`customLon${j}`];
                const hazardName = SimpleHoleData[`customName${j}`];

                if (customLat && customLon) {
                  let isTeeCenterInsideBackGround = booleanPointInPolygon(
                    [customLat, customLon],
                    {
                      type: "Polygon",
                      coordinates: backgroundBounds,
                    }
                  );
                  if (!isTeeCenterInsideBackGround) {
                    errMsg = `Hazard  ${hazardName} of hole ${SimpleHoleData?.holeNumber} is outside the background`;
                    success = false;
                    reject({ errMsg, success });
                  }
                }
              }
            }
          }
        }
      }

      resolve({ errMsg, success });
    } catch (error) {
      reject({ errMsg: error, success: false });
    }
  });
};
export const convertToLatLngArrayOfObject=(array)=>{
  return array.map(coords => {
    return { lat: coords[0], lng: coords[1] };
});
}

export  const getScreenMeasurement=()=>{
  return{width:window.screen.width,height:window.screen.height}
}

export const authenticationForCourseMap = (authenticationModuleArrayCode)=>{
const userDetails =  JSON.parse(localStorage.getItem("profile_data"));

 const userDetailsModuleArray =  userDetails?.moduleArray;

 if(userDetailsModuleArray?.includes(authenticationModuleArrayCode)){
  return true;
 }
} 

export const dateTimeFormat = (dateString) => {
  const inputDate = moment(dateString);
  // Desired output format
  const outputFormat = "MM/DD/YY hh:mm A";
  // Format the input date to the desired output format
  const formatedDateTime = inputDate.format(outputFormat);
  
  return formatedDateTime;
}

export const dateTimeFormatForMappingStatus = (dateString) => {
if(dateString){
  const parsedDate = moment(dateString, 'YYYY-MM-DD HH:mm:ss');
  // Format the parsed date according to the desired format
  const formatedDateTime = parsedDate.format('MM/DD/YY - HH.mm.ss');
  return formatedDateTime;
  
}

}


export const calculatedSum = (arr) =>{
  return arr?.reduce((acc, val) => acc + val, 0);
}

export const calculateSumforIndex = (holeArray ,startIndex ,endIndex) => {
  const sumofTeeIndex = holeArray?.slice(startIndex, endIndex).reduce((acc, curr) => acc + curr, 0);

  // const sumofTeeIndex = holeArray.slice(0, 9).reduce((acc, curr) => acc + curr, 0);
  return sumofTeeIndex;
}

export function truncateString(str, maxLength) {
  if (str?.length <= maxLength) return str; 

  return str?.slice(0, maxLength) + "..."; 
}


// Function to calculate the distance between two lat/lng points using Leaflet
const calculateDistance = (latLng1, latLng2) => {
  return L.latLng(latLng1).distanceTo(L.latLng(latLng2)); // Returns distance in meters
};

// Find the closest point in `a` to `b`
export const findClosestIndex = (points, target) => {
  let closestIndex = -1;
  let minDistance = Infinity;

  points.forEach((point, index) => {
    const distance = calculateDistance(point, target);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
};



export const buildPayloadFromHoleData = (holeData, index) => {
  const result = [];

  const hole = holeData[index];
  if (!hole) return result;

  Object.keys(hole).forEach((key) => {
    const element = hole[key];

    if (element && element.Shapes && Array.isArray(element.Shapes.Shape)) {
      element.Shapes.Shape.forEach((shape) => {
        if (shape && shape.id) {
          result.push({
            active: 0,
            id_courseGPSVector: shape.id,
            element: key, 
          });
        }
      });
    }
  });

  return result;
};
export const getSelectedIds = (holeData, index) => {
  const result = [];

  const hole = holeData[index];
  if (!hole) return result;

  Object.keys(hole).forEach((key) => {
    const element = hole[key];

    if (element && element.Shapes && Array.isArray(element.Shapes.Shape)) {
      element.Shapes.Shape.forEach((shape) => {
        if (shape && shape.id) {
          result.push(
            shape.id
          );
        }
      });
    }
  });

  return result;
};


export const holeElementsName = (selectedShape)=> {

  if(selectedShape === "practicegreen"){
    return "Practice Green"
  }else if(selectedShape === "parkinglot"){
    return "Parking Lot"
  }else{
    return selectedShape
  }

}

// Helpers to normalize/validate coordinates
  export const toTuple = (p) => {
    if (!p) return null;
    if (Array.isArray(p)) {
      // [lat, lng] or [lng, lat]? Your code consistently uses [lat, lng].
      const [a, b] = p;
      const lat = Number(a), lng = Number(b);
      return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
    }
    if (typeof p === "object" && p.lat != null && p.lng != null) {
      const lat = Number(p.lat), lng = Number(p.lng);
      return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
    }
    return null;
  };

  export const pushMany = (arr, items) => {
    items.forEach((pt) => {
      const t = toTuple(pt);
      if (t) arr.push(t);
    });
  };

  export const isNumber = (val) => /^\d+$/.test((val || "").trim());
	export const isIdCode12 = v => /^[\w-]{12}$/.test((v || "").trim());

export const generateBackgroundFromPerimeters = (holeWiseData, clubhouseCoords) => {
  if (!holeWiseData || !Array.isArray(holeWiseData)) return null;

  const perimeters = holeWiseData.filter(
    (item) => item?.label === "Perimeter" && item?.hole > 0
  );

  if (perimeters.length === 0) return null;

  // Buffer each perimeter individually by 200m, then union
  const bufferedPolygons = [];
  for (const perim of perimeters) {
    const coords = perim?.list?.[0];
    if (!coords || coords.length < 3) continue;

    // Convert [lat, lng] to [lng, lat] for Turf
    const ring = coords.map((p) => [p[1], p[0]]);
    // Ensure ring is closed
    if (
      ring[0][0] !== ring[ring.length - 1][0] ||
      ring[0][1] !== ring[ring.length - 1][1]
    ) {
      ring.push([...ring[0]]);
    }

    try {
      const poly = turfPolygon([ring]);
      const buffered = turfBuffer(poly, 200, { units: "meters" });
      if (buffered) bufferedPolygons.push(buffered);
    } catch (_) {
      // skip invalid polygons
    }
  }

  // Include clubhouse center as a buffered point so background covers it
  const hasClubhouse =
    clubhouseCoords &&
    clubhouseCoords.clubLat &&
    clubhouseCoords.clubLon &&
    clubhouseCoords.clubLat !== 0 &&
    clubhouseCoords.clubLon !== 0 &&
    clubhouseCoords.clubLat !== -1 &&
    clubhouseCoords.clubLon !== -1;

  if (hasClubhouse) {
    try {
      const clubPoint = point([clubhouseCoords.clubLon, clubhouseCoords.clubLat]);
      const bufferedClub = turfBuffer(clubPoint, 200, { units: "meters" });
      if (bufferedClub) bufferedPolygons.push(bufferedClub);
    } catch (_) {
      // skip
    }
  }

  if (bufferedPolygons.length === 0) return null;

  // Union all buffered polygons
  let shape = bufferedPolygons[0];
  for (let i = 1; i < bufferedPolygons.length; i++) {
    try {
      const merged = turfUnion(shape, bufferedPolygons[i]);
      if (merged) shape = merged;
    } catch (_) {
      // if union fails, continue
    }
  }

  // If still MultiPolygon (holes are geographically separated),
  // bridge clusters with buffered corridors between their centroids
  if (shape?.geometry?.type === "MultiPolygon") {
    const subPolygons = shape.geometry.coordinates.map((coords) =>
      turfPolygon(coords)
    );

    // Connect each cluster to its nearest neighbour via a 200m-wide corridor
    const connected = new Set([0]);
    let merged = subPolygons[0];

    while (connected.size < subPolygons.length) {
      let bestFrom = null;
      let bestTo = null;
      let bestDist = Infinity;

      for (const fi of connected) {
        const cA = turfCentroid(subPolygons[fi]);
        for (let ti = 0; ti < subPolygons.length; ti++) {
          if (connected.has(ti)) continue;
          const cB = turfCentroid(subPolygons[ti]);
          const d = turfDistance(cA, cB, { units: "meters" });
          if (d < bestDist) {
            bestDist = d;
            bestFrom = fi;
            bestTo = ti;
          }
        }
      }

      if (bestTo === null) break;
      connected.add(bestTo);

      // Build a corridor between the two centroids
      try {
        const cA = turfCentroid(subPolygons[bestFrom]).geometry.coordinates;
        const cB = turfCentroid(subPolygons[bestTo]).geometry.coordinates;
        const corridor = turfBuffer(
          turfLineString([cA, cB]),
          200,
          { units: "meters" }
        );
        merged = turfUnion(merged, subPolygons[bestTo]);
        if (corridor) merged = turfUnion(merged, corridor);
      } catch (_) {
        try { merged = turfUnion(merged, subPolygons[bestTo]); } catch (_e) {}
      }
    }

    if (merged) shape = merged;
  }

  // Simplify to reduce vertex count for easier manual editing
  let finalShape = turfSimplify(shape, {
    tolerance: 0.0003,
    highQuality: true,
  });

  const resultRing = finalShape.geometry.coordinates[0];

  // Convert back to [lat, lng] for Leaflet
  const leafletCoords = resultRing.map((c) => [c[1], c[0]]);

  // Build "lat,lng lat,lng ..." string
  const pointsString = leafletCoords
    .map((c) => `${c[0]},${c[1]}`)
    .join(" ");

  return { leafletCoords, pointsString };
};

export const findNearestDistanceToPerimeters = (cursorLatLng, holeWiseData) => {
  if (!cursorLatLng || !holeWiseData) return null;

  const perimeters = holeWiseData.filter(
    (item) => item?.label === "Perimeter" && item?.hole > 0
  );
  if (perimeters.length === 0) return null;

  const cursorPoint = point([cursorLatLng.lng, cursorLatLng.lat]);

  let minDist = Infinity;
  let closestPoint = null;

  for (const perim of perimeters) {
    const coords = perim?.list?.[0];
    if (!coords || coords.length < 2) continue;

    // Convert [lat, lng] to [lng, lat] for Turf lineString
    const ring = coords.map((p) => [p[1], p[0]]);
    // Close the ring if needed
    if (
      ring[0][0] !== ring[ring.length - 1][0] ||
      ring[0][1] !== ring[ring.length - 1][1]
    ) {
      ring.push([...ring[0]]);
    }

    try {
      const line = turfLineString(ring);
      const nearest = nearestPointOnLine(line, cursorPoint);
      const dist = turfDistance(cursorPoint, nearest, { units: "meters" });

      if (dist < minDist) {
        minDist = dist;
        closestPoint = [
          nearest.geometry.coordinates[1],
          nearest.geometry.coordinates[0],
        ];
      }
    } catch (_) {
      // skip invalid
    }
  }

  if (closestPoint === null) return null;

  return {
    distance: minDist,
    nearestPoint: closestPoint,
  };
};


export const hasSelfIntersection = (pointList, isClosedRing) => {
  const points = Array.isArray(pointList) ? pointList : [];
  if (points.length < 4) return false;

  const ccw = (a, b, c) =>
    (c[1] - a[1]) * (b[0] - a[0]) > (b[1] - a[1]) * (c[0] - a[0]);
  const segmentsCross = (a, b, c, d) =>
    ccw(a, c, d) !== ccw(b, c, d) && ccw(a, b, c) !== ccw(a, b, d);

  const segmentCount = isClosedRing ? points.length : points.length - 1;

  for (let i = 0; i < segmentCount; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    for (let j = i + 2; j < segmentCount; j++) {
      if (isClosedRing && i === 0 && j === segmentCount - 1) continue;
      const c = points[j];
      const d = points[(j + 1) % points.length];
      if (segmentsCross(a, b, c, d)) return true;
    }
  }
  return false;
};
